import {
  AuditLogResource,
  ListAuditLogsFilterParameterResourceTypeEq
} from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";

export function useWorkLogHistoryResources(
  workLogId: string
): AuditLogResource[] {
  return useMemo(
    () => [
      {
        resourceType: ListAuditLogsFilterParameterResourceTypeEq.WORK_LOG,
        resourceId: workLogId
      }
    ],
    [workLogId]
  );
}
